// 自定义组件
import IForm from "./IForm";
import ITable from "./ITable";
import MyCheckBox from  "./MyCheckBox"
import MyCascader from "./MyCascader.vue";

export default Vue => {
  const components = {
    IForm,
    ITable,
    MyCheckBox,
    MyCascader
  };
  for (const key of Object.keys(components)) {
    Vue.component(key, components[key]);
  }
};
